import { render, staticRenderFns } from "./KegelProvenBenefits.vue?vue&type=template&id=d698728c&"
import script from "./KegelProvenBenefits.vue?vue&type=script&lang=js&"
export * from "./KegelProvenBenefits.vue?vue&type=script&lang=js&"
import style0 from "./KegelProvenBenefits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports